"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistrictChoice = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var semantic_ui_react_1 = require("semantic-ui-react");
var searchParamsSlice_1 = require("../../../features/searchParams/searchParamsSlice");
var useTranslationNs_1 = require("../../../hooks/useTranslationNs");
var FilterDropdown_1 = __importDefault(require("../FilterDropdown"));
var FilterSummary_1 = __importDefault(require("../FilterSummary"));
var DistrictsList_1 = __importDefault(require("./DistrictsList"));
var SelectedValues_1 = __importDefault(require("../SelectedValues"));
var languageSlice_1 = require("../../../features/languages/languageSlice");
var DistrictChoice = function (_a) {
    var _b;
    var _c = _a.filter, label = _c.label, name = _c.name, toggleDropdown = _a.toggleDropdown, onSelect = _a.onSelect, appliedFilters = _a.appliedFilters;
    var allFilter = react_redux_1.useSelector(searchParamsSlice_1.getFiltersGroup);
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var states = (allFilter === null || allFilter === void 0 ? void 0 : allFilter.state) ? allFilter === null || allFilter === void 0 ? void 0 : allFilter.state.options : [];
    var getTranslation = useTranslationNs_1.useTranslationNs('common', 'FILTER');
    var selectedDistrictsData = react_redux_1.useSelector(searchParamsSlice_1.useSelectSelectedDistrictsData);
    var _d = react_1.useState([]), districts = _d[0], setDistricts = _d[1];
    var _e = react_1.useState(''), searchValue = _e[0], setSearchValue = _e[1];
    react_1.useEffect(function () {
        setDistricts(selectedDistrictsData);
    }, [selectedDistrictsData]);
    var onChange = function (event) {
        var value = event.target.value;
        setSearchValue(value);
        var filteredData = selectedDistrictsData.filter(function (district) {
            return district.translations
                ? district.translations[currentLanguage]
                    .toLowerCase()
                    .startsWith(value.toLowerCase())
                : district.text.toLowerCase().startsWith(value.toLowerCase());
        });
        setDistricts(filteredData);
    };
    var handleToggleClick = function () {
        selectedDistrictsData.length && toggleDropdown();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FilterSummary_1.default, { handleClick: handleToggleClick, label: label.toLocaleUpperCase(), isDisabled: !selectedDistrictsData.length },
            districts && (react_1.default.createElement(SelectedValues_1.default, { selected: appliedFilters.district || [], states: districts })),
            !((_b = appliedFilters.district) === null || _b === void 0 ? void 0 : _b.length) && (react_1.default.createElement("span", { className: "default-val" }, getTranslation('CHOOSE')))),
        react_1.default.createElement(FilterDropdown_1.default, { handleClick: toggleDropdown, label: label.toUpperCase(), filterName: name },
            react_1.default.createElement("div", { className: "district-choices" },
                react_1.default.createElement("div", { className: "search-bar" },
                    react_1.default.createElement(semantic_ui_react_1.Input, { icon: true, placeholder: "Search...", onChange: onChange },
                        react_1.default.createElement("input", null),
                        react_1.default.createElement(semantic_ui_react_1.Icon, { name: "search" }))),
                react_1.default.createElement("div", { className: "district-scroller" },
                    react_1.default.createElement(DistrictsList_1.default, { districts: districts, onSelect: onSelect, states: states, selectedDistricts: appliedFilters.district || [], searchValue: searchValue, currentLanguage: currentLanguage }))))));
};
exports.DistrictChoice = DistrictChoice;
